import type { Review } from '@skin-seoul/service';
import type { Product } from '@skin-seoul/service';

/**
 * Extracts unique product IDs from an array of reviews and returns them as a comma-separated string
 * @param reviews - Array of review objects
 * @returns Comma-separated string of unique product IDs
 */
export function extractProductIdsFromReviews(reviews: Review[]): string {
  const uniqueProductIds = [...new Set(reviews.map((review) => review.productId))];
  return uniqueProductIds.join(',');
}

/**
 * Creates a lookup map of product ID to product for efficient access
 * @param products - Array of product objects
 * @returns Record mapping product ID to product object
 */
export function createProductMap(products: Product[]): Record<number, Product> {
  const map: Record<number, Product> = {};
  products.forEach((product) => {
    map[product.productId] = product;
  });
  return map;
}
